import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next";
import RefGroup from "../assets/icons/ref-group.svg";
import TicketsIcon from "../assets/icons/ticket-pink-icon.svg";
import WinningIcon from "../assets/icons/winning-icon.svg";
import QuestCard from "../components/QuestCard";
import { ticketsInCurrentLevel, userInfo, userLvl } from "../web3";

function Quests(props: any) {

    const [buyReward, setBuyReward] = useState(0)
    const [soldReward, setSoldReward] = useState(0)
    const [userLevel, setUserLevel] = useState(0)
    const [refCount, setRefCount] = useState(0)
    const [ticketsInLevel, setTicketsInLevel] = useState(0)
    const [numberOfWonCyclesInRow, setNumberOfWonCyclesInRow] = useState(0)
    const [rawBonus, setRowBouns] = useState(0)


    const { t } = useTranslation();

    // 0xa129691F5b03dEEB54df6d8c9fE4DB977D5a94A7
    useEffect(() => {
        userInfo(props?.address).then((res) => {
            console.log("USERD", res);

            setBuyReward(res?.buyRewards)
            setSoldReward(res?.soldRewards)
            setRefCount(res?.referralsCount)
            setNumberOfWonCyclesInRow(res?.numberOfWonCyclesInRow)
            setRowBouns(res?.inRowBonus)

        })

        userLvl(props?.address).then((res) => {
            setUserLevel(res)
        })
        ticketsInCurrentLevel(props?.address).then((res) => { setTicketsInLevel(res) })

    }, [buyReward, userLevel, ticketsInLevel, soldReward, refCount, props?.address])

    const questData = [
        {
            icon: RefGroup,
            name: t("Привлечь 10 рефералов"),
            count: refCount,
            allCount: '10',
            earning: '1 USDT',
            allEarning: soldReward / 10 ** 18,
        },
        {
            icon: WinningIcon,
            name: "Победить 3 раза подряд",
            count: numberOfWonCyclesInRow,
            allCount: '3',
            earning: "10 USDT",
            allEarning: rawBonus / 10 ** 18,
        },
        {
            icon: TicketsIcon,
            name:
                Number(userLevel) === 3
                    ? t("Купить 50 билетов")
                    : Number(userLevel) === 2
                        ? t("Купить 25 билетов")
                        : t("Купить 10 билетов"),
            count: ticketsInLevel,
            allCount:
                Number(userLevel) === 3
                    ? '50'
                    : Number(userLevel) === 2
                        ? '25'
                        : '10',
            earning: Number(userLevel) === 3
                ? '30 USDT'
                : Number(userLevel) === 2
                    ? '10 USDT'
                    : '1 USDT',
            allEarning: (Number(buyReward) / 10 ** 18).toFixed(0),
            lvl: Number(userLevel)
        }

    ]

    return (
        <div className="quests">
            <span className="quests_title">
                {t('Задания')}
            </span>
            {questData.map((questItem: any, index: number) => {
                return (
                    <QuestCard
                        key={index}
                        questItem={questItem}
                    />
                )
            })}
        </div>
    )
}

export default Quests
